import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { fontDisplay, fontText, StylesIndexInjections } from 'common-react';
import { layerBoxShadow, zIndex } from '../../theme/constants';
import { fieldBoxShadow } from '../../styles/mixins';


export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    top: 96,
    position: 'absolute',
    zIndex: zIndex.autocompleteDropdownZIndex,
    padding: 16,
    '& input': {
      '&::placeholder': {
        color: theme.color.greys[80],
        opacity: 1,
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      position: 'relative',
      top: 0,
      zIndex: 0,
    },
  },
  rootAbove: {
    top: -77,
    [theme.breakpoints.down('sm')]: {
      top: 0,
    },
  },
  autocompleteWrapper: {
    position: 'relative',
    flex: 1,
    '& .MuiFormLabel-root': {
      marginBottom: 8
    },
    '& .MuiAutocomplete-popper': {
      top: '100%',
      marginTop: 8,
      padding: '103px 4px 4px',
      border: `1px solid ${theme.color.greys[30]}`,
      maxHeight: 440,
      background: theme.color.greys[0],
      borderRadius: 8,
      boxShadow: layerBoxShadow,
      left: 0,
      right: 0,
      width: '100% !important',
    },
    '& .MuiAutocomplete-popper.above': {
      bottom: 60,
      top: 'auto',
      paddingBottom: 95,
      paddingTop: 16,
    },
  },
  input: {
    font: fontText('normal', theme.fontSize.base, 20),
    color: theme.color.greys[80],
    [theme.breakpoints.down('sm')]: {
      font: fontText('normal', theme.fontSize.s, 16),
    },
  },
  optionsWrapper: {
    maxHeight: 440,
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      border: 'none',
      boxShadow: 'none',
      paddingBottom: 0,
      borderRadius: 0,
      marginTop: 24,
      maxHeight: 'unset',
      height: '100%',
    },
  },
  paper: {
    padding: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderRadius: 0,
    border: 0,
  },
  listbox: {
    maxHeight: 320,
    overflow: 'auto',
    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'unset'
    },
  },
  option: {
    font: fontDisplay('normal', theme.fontSize.base, 24),
    padding: 16,
    color: theme.color.greys[80],
    borderRadius: 8,
    '&[data-focus="true"], &[aria-selected="true"]': {
      boxShadow: fieldBoxShadow(theme).bs2,
      backgroundColor: theme.color.greys[0],
    },
    [theme.breakpoints.down('sm')]: {
      font: fontDisplay('normal', theme.fontSize.base, 24),
      margin: 0,
      minHeight: 56,
    }
  },
  noOptions: {
    font: fontText('normal', theme.fontSize.base, 20),
    color: theme.color.greys[40]
  },
  filterText: {
    color: theme.color.oranges[50]
  },
  groupLabel: {
    padding: '0 4px',
    marginBottom: 16,
    font: fontText('normal', theme.fontSize.s, 20),
    color: theme.color.greys[60],
  },
  groupList: {
    position: 'relative',
    marginBottom: 16,
    paddingBottom: 16,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 20,
      paddingBottom: 20,
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      height: 1,
      width: '100%',
      backgroundColor: theme.variables.isDarkTheme ? theme.color.greys[20] : theme.color.greys[30],
      transform: 'translateX(-50%)',
    }
  },
  modalInner: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 24,
      height: '100%'
    },
  },
  hiddenPopupIndicator: {
    display: 'none'
  },
  desktopBackdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: zIndex.autocompleteDropdownZIndex - 1,
  },


}), { name: 'Autocomplete', index: StylesIndexInjections.UI_MOLECULES });